import React from 'react';

const SvgCheck = ({ title, ...props }) => (
  <svg viewBox="0 0 390 390" {...props}>
    {title ? <title>{title}</title> : null}
    <path d="M143.2 341.5L1 199.3l37.7-37.8L143.2 266 352.3 56.9 390 94.6z" />
  </svg>
);

export default SvgCheck;
